import { PickupParticipantListPage } from "components/shared/pickupParticipants";

export const PAGE_SIZE = 10;

const WPSCheckinAttractionParticipantsListPage = () => (
  <PickupParticipantListPage kind="attraction" variant="wps" />
);

export default WPSCheckinAttractionParticipantsListPage;
